module.exports = __webpack_public_path__ + "static/media/slider_active_new.97f51831.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_active_new.svg
// module id = 1062
// module chunks = 0